import { useContext } from 'react'
import { ApolloQueueContext } from './ApolloQueueContext'

export function useApolloQueue() {
  return useContext(ApolloQueueContext)
}
